import React, { Component } from 'react';
import { unescapeHTML, titleize } from 'underscore.string';
import { withTranslation } from 'react-i18next';
import CustomerSearch from '../../site/customer-search';
import CargomaticCard from '../../v2/card';
import CustomersActionCreators from '../../../actions/CustomersActionCreators';
class AssociateAccount extends Component {
    constructor(props) {
        super(props);
        this.handleReset = () => {
            CustomersActionCreators.associateShipper({
                shipperId: this.props.userId,
                masterId: this.props.userId,
            });
        };
        this.state = {
            associationId: null,
        };
    }
    saveAssociation() {
        CustomersActionCreators.associateShipper({
            shipperId: this.props.userId,
            masterId: this.state.associationId,
        });
    }
    render() {
        const { t } = this.props;
        const hasAssociation = this.props.currentAssociation &&
            this.props.userId !== this.props.currentAssociation.id;
        let masterAccountLink;
        if (hasAssociation) {
            masterAccountLink = `/users/${this.props.currentAssociation.id}`;
        }
        return (React.createElement(CargomaticCard, { header: () => (React.createElement("h3", { className: "my-0 text-xl font-medium" }, t('MASTER_ACCOUNT'))), footer: () => (React.createElement("div", { className: "flex items-center justify-end -mx-2 text-right" },
                React.createElement("div", { className: "px-2" },
                    React.createElement("button", { className: "my-2 button button-green", onClick: () => this.saveAssociation() }, t('ASSOCIATE'))),
                hasAssociation && (React.createElement("div", { className: "px-2" },
                    React.createElement("button", { className: "button button-secondary", onClick: this.handleReset }, titleize(t('RESET'))))))), grayFooter: true },
            hasAssociation && (React.createElement("div", { className: "flex items-center mb-2" },
                React.createElement("label", { className: "my-0 mr-2 form-label" },
                    t('MASTER_ACCOUNT'),
                    ":"),
                React.createElement("strong", { className: "my-0" },
                    React.createElement("a", { href: masterAccountLink, target: "_blank", rel: "noopener noreferrer" }, unescapeHTML(this.props.currentAssociation.name))))),
            !hasAssociation && (React.createElement("label", { className: "mb-2 form-lbel" }, t('LINK_ACCOUNT'))),
            React.createElement("div", { className: "mb-4" },
                React.createElement(CustomerSearch, { type: "master_shippers", onSelect: (_name, details) => {
                        this.setState({ associationId: details.value });
                    } }))));
    }
}
AssociateAccount.defaultProps = { currentAssociation: {} };
export default withTranslation()(AssociateAccount);
